/* tslint:disable */
/* eslint-disable */
/**
 * az-document
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 5.0.17-RELEASE 2022-12-01T14:13:02Z
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * The value to be parsed by the operator
 * @export
 * @interface AbstractDateSearchValue
 */
export interface AbstractDateSearchValue {
    /**
     *
     * @type {string}
     * @memberof AbstractDateSearchValue
     */
    '@class': string;
}
/**
 *
 * @export
 * @interface AssignBundleRequest
 */
export interface AssignBundleRequest {
    /**
     * The ids of documents
     * @type {Set<string>}
     * @memberof AssignBundleRequest
     */
    'ids': Set<string>;
    /**
     * The id of bundle
     * @type {string}
     * @memberof AssignBundleRequest
     */
    'bundleId': string;
    /**
     * Origin of documents
     * @type {string}
     * @memberof AssignBundleRequest
     */
    'origin'?: string;
}
/**
 *
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     *
     * @type {{ [key: string]: Array<string>; }}
     * @memberof Attachment
     */
    'headers'?: { [key: string]: Array<string>; };
    /**
     *
     * @type {object}
     * @memberof Attachment
     */
    'object'?: object;
    /**
     *
     * @type {ContentDisposition}
     * @memberof Attachment
     */
    'contentDisposition'?: ContentDisposition;
    /**
     *
     * @type {AttachmentDataHandler}
     * @memberof Attachment
     */
    'dataHandler'?: AttachmentDataHandler;
    /**
     *
     * @type {string}
     * @memberof Attachment
     */
    'contentId'?: string;
    /**
     *
     * @type {AttachmentContentType}
     * @memberof Attachment
     */
    'contentType'?: AttachmentContentType;
}
/**
 *
 * @export
 * @interface AttachmentContentType
 */
export interface AttachmentContentType {
    /**
     *
     * @type {string}
     * @memberof AttachmentContentType
     */
    'type'?: string;
    /**
     *
     * @type {string}
     * @memberof AttachmentContentType
     */
    'subtype'?: string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof AttachmentContentType
     */
    'parameters'?: { [key: string]: string; };
    /**
     *
     * @type {boolean}
     * @memberof AttachmentContentType
     */
    'wildcardType'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentContentType
     */
    'wildcardSubtype'?: boolean;
}
/**
 *
 * @export
 * @interface AttachmentDataHandler
 */
export interface AttachmentDataHandler {
    /**
     *
     * @type {AttachmentDataHandlerDataSource}
     * @memberof AttachmentDataHandler
     */
    'dataSource'?: AttachmentDataHandlerDataSource;
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandler
     */
    'name'?: string;
    /**
     *
     * @type {object}
     * @memberof AttachmentDataHandler
     */
    'inputStream'?: object;
    /**
     *
     * @type {object}
     * @memberof AttachmentDataHandler
     */
    'content'?: object;
    /**
     *
     * @type {object}
     * @memberof AttachmentDataHandler
     */
    'outputStream'?: object;
    /**
     *
     * @type {AttachmentDataHandlerCommandMap}
     * @memberof AttachmentDataHandler
     */
    'commandMap'?: AttachmentDataHandlerCommandMap;
    /**
     *
     * @type {Array<AttachmentDataHandlerTransferDataFlavorsInner>}
     * @memberof AttachmentDataHandler
     */
    'transferDataFlavors'?: Array<AttachmentDataHandlerTransferDataFlavorsInner>;
    /**
     *
     * @type {Array<AttachmentDataHandlerPreferredCommandsInner>}
     * @memberof AttachmentDataHandler
     */
    'preferredCommands'?: Array<AttachmentDataHandlerPreferredCommandsInner>;
    /**
     *
     * @type {Array<AttachmentDataHandlerPreferredCommandsInner>}
     * @memberof AttachmentDataHandler
     */
    'allCommands'?: Array<AttachmentDataHandlerPreferredCommandsInner>;
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandler
     */
    'contentType'?: string;
}
/**
 *
 * @export
 * @interface AttachmentDataHandlerCommandMap
 */
export interface AttachmentDataHandlerCommandMap {
    /**
     *
     * @type {Array<string>}
     * @memberof AttachmentDataHandlerCommandMap
     */
    'mimeTypes'?: Array<string>;
}
/**
 *
 * @export
 * @interface AttachmentDataHandlerDataSource
 */
export interface AttachmentDataHandlerDataSource {
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandlerDataSource
     */
    'name'?: string;
    /**
     *
     * @type {object}
     * @memberof AttachmentDataHandlerDataSource
     */
    'inputStream'?: object;
    /**
     *
     * @type {object}
     * @memberof AttachmentDataHandlerDataSource
     */
    'outputStream'?: object;
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandlerDataSource
     */
    'contentType'?: string;
}
/**
 *
 * @export
 * @interface AttachmentDataHandlerPreferredCommandsInner
 */
export interface AttachmentDataHandlerPreferredCommandsInner {
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandlerPreferredCommandsInner
     */
    'commandClass'?: string;
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandlerPreferredCommandsInner
     */
    'commandName'?: string;
}
/**
 *
 * @export
 * @interface AttachmentDataHandlerTransferDataFlavorsInner
 */
export interface AttachmentDataHandlerTransferDataFlavorsInner {
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'mimeType'?: string;
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'humanPresentableName'?: string;
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'primaryType'?: string;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassInputStream'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassByteBuffer'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'flavorTextType'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassReader'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassCharBuffer'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassSerializable'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'representationClassRemote'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'mimeTypeSerializedObject'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'defaultRepresentationClassAsString'?: string;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'flavorSerializedObjectType'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'flavorRemoteObjectType'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'flavorJavaFileListType'?: boolean;
    /**
     *
     * @type {string}
     * @memberof AttachmentDataHandlerTransferDataFlavorsInner
     */
    'subType'?: string;
}
/**
 *
 * @export
 * @interface BaseDocumentMetadataRequest
 */
export interface BaseDocumentMetadataRequest {
    /**
     * The id of the documents to search
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'id'?: Array<string>;
    /**
     * The bundle id of the documents to search
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'bundleId'?: string;
    /**
     * The owner of the document
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'ownerCode'?: string;
    /**
     * To include public document in search
     * @type {boolean}
     * @memberof BaseDocumentMetadataRequest
     */
    'includePublicDocument'?: boolean;
    /**
     * The category of the document
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'categories'?: Array<string>;
    /**
     * The scope of the document
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'scopes'?: Array<string>;
    /**
     * The origin of the document
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'origin'?: string;
    /**
     * The source of the document
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'source'?: string;
    /**
     * The type of the document
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * Document id in the document store
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'dmsId'?: string;
    /**
     * List of document status to filter
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'status'?: Array<string>;
    /**
     * Filter read or unread documents
     * @type {boolean}
     * @memberof BaseDocumentMetadataRequest
     */
    'read'?: boolean;
    /**
     * Filter expired or not expired documents. Automatic turn off when expirationDate is set. True only expired documents, False only not expired documents, Empty all documents without filter
     * @type {boolean}
     * @memberof BaseDocumentMetadataRequest
     */
    'expired'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof BaseDocumentMetadataRequest
     */
    'externalUrl'?: string;
    /**
     *
     * @type {DateSearchParamFilter}
     * @memberof BaseDocumentMetadataRequest
     */
    'creationDate'?: DateSearchParamFilter;
    /**
     *
     * @type {DateSearchParamFilter}
     * @memberof BaseDocumentMetadataRequest
     */
    'expirationDate'?: DateSearchParamFilter;
    /**
     * Filter by complexMetadata sub field
     * @type {{ [key: string]: object; }}
     * @memberof BaseDocumentMetadataRequest
     */
    'complexMetadata'?: { [key: string]: object; };
    /**
     *
     * @type {TextSearchParamFilter}
     * @memberof BaseDocumentMetadataRequest
     */
    'textSearch'?: TextSearchParamFilter;
    /**
     * The list of fields to filter with null value
     * @type {Array<string>}
     * @memberof BaseDocumentMetadataRequest
     */
    'fieldsWithNullValueFilter'?: Array<string>;
}
/**
 *
 * @export
 * @interface ChangeStatusRequest
 */
export interface ChangeStatusRequest {
    /**
     *
     * @type {Set<string>}
     * @memberof ChangeStatusRequest
     */
    'documentIds': Set<string>;
    /**
     *
     * @type {string}
     * @memberof ChangeStatusRequest
     */
    'status': string;
}
/**
 * CommunicationBean (ComplexMetadata)
 * @export
 * @interface CommunicationMetadataBean
 */
export interface CommunicationMetadataBean extends SimpleMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof CommunicationMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof CommunicationMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof CommunicationMetadataBean
     */
    'practiceType'?: string;
}
/**
 *
 * @export
 * @interface CommunicationMetadataBeanAllOf
 */
export interface CommunicationMetadataBeanAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof CommunicationMetadataBeanAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof CommunicationMetadataBeanAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof CommunicationMetadataBeanAllOf
     */
    'practiceType'?: string;
}
/**
 * Additional metadata infos of the document
 * @export
 * @interface ComplexMetadata
 */
export interface ComplexMetadata {
    /**
     *
     * @type {string}
     * @memberof ComplexMetadata
     */
    '@class': string;
}
/**
 * Contacts to send notification email to
 * @export
 * @interface ContactInfoBean
 */
export interface ContactInfoBean {
    /**
     * The id of contactInfo
     * @type {string}
     * @memberof ContactInfoBean
     */
    'id'?: string;
    /**
     * The channel of communication
     * @type {string}
     * @memberof ContactInfoBean
     */
    'channel'?: string;
    /**
     * The language of communication
     * @type {string}
     * @memberof ContactInfoBean
     */
    'language'?: string;
    /**
     * The email to send communication
     * @type {string}
     * @memberof ContactInfoBean
     */
    'email'?: string;
}
/**
 *
 * @export
 * @interface ContentDisposition
 */
export interface ContentDisposition {
    /**
     *
     * @type {string}
     * @memberof ContentDisposition
     */
    'type'?: string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof ContentDisposition
     */
    'parameters'?: { [key: string]: string; };
    /**
     *
     * @type {string}
     * @memberof ContentDisposition
     */
    'filename'?: string;
}
/**
 * metadata of contract documents
 * @export
 * @interface ContractMetadataBean
 */
export interface ContractMetadataBean extends FeqMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ContractMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ContractMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'practiceType'?: string;
    /**
     * Document data from signroom
     * @type {boolean}
     * @memberof ContractMetadataBean
     */
    'signroom': boolean;
    /**
     * (Internal use) Signature process type code
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'processTypeCode'?: string;
    /**
     * Signature date
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'signDate'?: string;
    /**
     * (Internal use) External signature provider system creation date
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'envelopeCreationDate'?: string;
    /**
     * (Internal use) External signature provider system id
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'envelopeId'?: string;
    /**
     * (Internal use) True if the document belongs to a signed bundle
     * @type {boolean}
     * @memberof ContractMetadataBean
     */
    'signed'?: boolean;
    /**
     * Document Type for legally compliant long-term archiving system
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'documentClass'?: string;
    /**
     * (Internal use) True if the document must be archived into legally compliant long-term archiving system
     * @type {boolean}
     * @memberof ContractMetadataBean
     */
    'trustArchive'?: boolean;
    /**
     * Contract id for legally compliant long-term archiving system
     * @type {string}
     * @memberof ContractMetadataBean
     */
    'contractId'?: string;
}
/**
 *
 * @export
 * @interface ContractMetadataBeanAllOf
 */
export interface ContractMetadataBeanAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ContractMetadataBeanAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ContractMetadataBeanAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'practiceType'?: string;
    /**
     * Document data from signroom
     * @type {boolean}
     * @memberof ContractMetadataBeanAllOf
     */
    'signroom'?: boolean;
    /**
     * (Internal use) Signature process type code
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'processTypeCode'?: string;
    /**
     * Signature date
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'signDate'?: string;
    /**
     * (Internal use) External signature provider system creation date
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'envelopeCreationDate'?: string;
    /**
     * (Internal use) External signature provider system id
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'envelopeId'?: string;
    /**
     * (Internal use) True if the document belongs to a signed bundle
     * @type {boolean}
     * @memberof ContractMetadataBeanAllOf
     */
    'signed'?: boolean;
    /**
     * Document Type for legally compliant long-term archiving system
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'documentClass'?: string;
    /**
     * (Internal use) True if the document must be archived into legally compliant long-term archiving system
     * @type {boolean}
     * @memberof ContractMetadataBeanAllOf
     */
    'trustArchive'?: boolean;
    /**
     * Contract id for legally compliant long-term archiving system
     * @type {string}
     * @memberof ContractMetadataBeanAllOf
     */
    'contractId'?: string;
}
/**
 * Filter by document expiration date
 * @export
 * @interface DateSearchParamFilter
 */
export interface DateSearchParamFilter {
    /**
     * The operator to be applied on the field
     * @type {string}
     * @memberof DateSearchParamFilter
     */
    'operator': DateSearchParamFilterOperatorEnum;
    /**
     *
     * @type {AbstractDateSearchValue}
     * @memberof DateSearchParamFilter
     */
    'value': AbstractDateSearchValue;
    /**
     * The name of the field to be filtered
     * @type {string}
     * @memberof DateSearchParamFilter
     */
    'field': string;
}

export const DateSearchParamFilterOperatorEnum = {
    Before: 'BEFORE',
    BeforeOrEqual: 'BEFORE_OR_EQUAL',
    After: 'AFTER',
    AfterOrEqual: 'AFTER_OR_EQUAL',
    Between: 'BETWEEN',
    EqualsTimestamp: 'EQUALS_TIMESTAMP'
} as const;

export type DateSearchParamFilterOperatorEnum = typeof DateSearchParamFilterOperatorEnum[keyof typeof DateSearchParamFilterOperatorEnum];

/**
 *
 * @export
 * @interface DeleteDocumentRequest
 */
export interface DeleteDocumentRequest {
    /**
     * The id list of the documents to delete
     * @type {Set<string>}
     * @memberof DeleteDocumentRequest
     */
    'ids'?: Set<string>;
    /**
     * The owner of the document to delete
     * @type {string}
     * @memberof DeleteDocumentRequest
     */
    'ownerCode'?: string;
    /**
     * The type of the document to delete. It must be used with another parameter (e.g. if ownerCode parameter is not empty then documentType can be used)
     * @type {string}
     * @memberof DeleteDocumentRequest
     */
    'documentType'?: string;
    /**
     * Document id list of documents in the document store to delete
     * @type {Set<string>}
     * @memberof DeleteDocumentRequest
     */
    'dmsIds'?: Set<string>;
}
/**
 * Disposition Data (ComplexMetadata), complexMetadata used for digital sign flows
 * @export
 * @interface DispositionMetadataBean
 */
export interface DispositionMetadataBean extends FeqMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof DispositionMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof DispositionMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'practiceType'?: string;
    /**
     * Document data from signroom
     * @type {boolean}
     * @memberof DispositionMetadataBean
     */
    'signroom': boolean;
    /**
     * (Internal use) Signature process type code
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'processTypeCode'?: string;
    /**
     * Signature date
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'signDate'?: string;
    /**
     * (Internal use) External signature provider system creation date
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'envelopeCreationDate'?: string;
    /**
     * (Internal use) External signature provider system id
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'envelopeId'?: string;
    /**
     * (Internal use) True if the document belongs to a signed bundle
     * @type {boolean}
     * @memberof DispositionMetadataBean
     */
    'signed'?: boolean;
    /**
     * Document Type for legally compliant long-term archiving system
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'documentClass'?: string;
    /**
     * (Internal use) True if the document must be archived into legally compliant long-term archiving system
     * @type {boolean}
     * @memberof DispositionMetadataBean
     */
    'trustArchive'?: boolean;
    /**
     * Contract id for legally compliant long-term archiving system
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'contractId'?: string;
    /**
     * Financial plan id
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'planId'?: string;
    /**
     * Service Type Code
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'serviceTypeCode': string;
    /**
     * Report ID
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'reportId'?: string;
    /**
     *
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'reportMasterId'?: string;
    /**
     * Report Category
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'reportCategory'?: string;
    /**
     * Report type
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'reportType'?: string;
    /**
     * Module ID
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'moduleId'?: string;
    /**
     * Order list
     * @type {Array<OrderMetadataBean>}
     * @memberof DispositionMetadataBean
     */
    'orders'?: Array<OrderMetadataBean>;
    /**
     * Total amount
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'totalAmount'?: string;
    /**
     * Total Amount Currency
     * @type {string}
     * @memberof DispositionMetadataBean
     */
    'totalAmountCurrency'?: string;
}
/**
 *
 * @export
 * @interface DispositionMetadataBeanAllOf
 */
export interface DispositionMetadataBeanAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof DispositionMetadataBeanAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof DispositionMetadataBeanAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'practiceType'?: string;
    /**
     * Document data from signroom
     * @type {boolean}
     * @memberof DispositionMetadataBeanAllOf
     */
    'signroom'?: boolean;
    /**
     * (Internal use) Signature process type code
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'processTypeCode'?: string;
    /**
     * Signature date
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'signDate'?: string;
    /**
     * (Internal use) External signature provider system creation date
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'envelopeCreationDate'?: string;
    /**
     * (Internal use) External signature provider system id
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'envelopeId'?: string;
    /**
     * (Internal use) True if the document belongs to a signed bundle
     * @type {boolean}
     * @memberof DispositionMetadataBeanAllOf
     */
    'signed'?: boolean;
    /**
     * Document Type for legally compliant long-term archiving system
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'documentClass'?: string;
    /**
     * (Internal use) True if the document must be archived into legally compliant long-term archiving system
     * @type {boolean}
     * @memberof DispositionMetadataBeanAllOf
     */
    'trustArchive'?: boolean;
    /**
     * Contract id for legally compliant long-term archiving system
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'contractId'?: string;
    /**
     * Financial plan id
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'planId'?: string;
    /**
     * Service Type Code
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'serviceTypeCode'?: string;
    /**
     * Report ID
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'reportId'?: string;
    /**
     *
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'reportMasterId'?: string;
    /**
     * Report Category
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'reportCategory'?: string;
    /**
     * Report type
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'reportType'?: string;
    /**
     * Module ID
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'moduleId'?: string;
    /**
     * Order list
     * @type {Array<OrderMetadataBean>}
     * @memberof DispositionMetadataBeanAllOf
     */
    'orders'?: Array<OrderMetadataBean>;
    /**
     * Total amount
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'totalAmount'?: string;
    /**
     * Total Amount Currency
     * @type {string}
     * @memberof DispositionMetadataBeanAllOf
     */
    'totalAmountCurrency'?: string;
}
/**
 *
 * @export
 * @interface DocumentBean
 */
export interface DocumentBean {
    /**
     * The id of the metadata object
     * @type {string}
     * @memberof DocumentBean
     */
    'id'?: string;
    /**
     * The mime type of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'mimeType'?: string;
    /**
     * The hash of the metadata object
     * @type {string}
     * @memberof DocumentBean
     */
    'hash'?: string;
    /**
     * The category of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'category'?: string;
    /**
     * The scope of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'scope'?: string;
    /**
     * The origin of the document, used to define internal flows, grant univocity with bundleId
     * @type {string}
     * @memberof DocumentBean
     */
    'origin'?: string;
    /**
     * The source of the document, used to define external flows
     * @type {string}
     * @memberof DocumentBean
     */
    'source'?: string;
    /**
     * The name of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'documentName'?: string;
    /**
     * The type of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'documentType'?: string;
    /**
     * Size of the document in bytes
     * @type {number}
     * @memberof DocumentBean
     */
    'documentSize'?: number;
    /**
     * The foreign key to the document id on the dms
     * @type {string}
     * @memberof DocumentBean
     */
    'dmsId'?: string;
    /**
     * The document URL
     * @type {string}
     * @memberof DocumentBean
     */
    'documentURL'?: string;
    /**
     * The code of the owner of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'ownerCode'?: string;
    /**
     * The id of the bundle, with this info can group a different files
     * @type {string}
     * @memberof DocumentBean
     */
    'bundleId'?: string;
    /**
     * The status of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'status'?: string;
    /**
     * If the document has been read its value is TRUE, else is FALSE
     * @type {boolean}
     * @memberof DocumentBean
     */
    'read'?: boolean;
    /**
     * The creation date of the document
     * @type {string}
     * @memberof DocumentBean
     */
    'creationDate'?: string;
    /**
     * The accrual date of the document (competence date)
     * @type {string}
     * @memberof DocumentBean
     */
    'accrualDate'?: string;
    /**
     * Expiration date, documents will not be searchable after this date
     * @type {string}
     * @memberof DocumentBean
     */
    'expirationDate'?: string;
    /**
     * If the document has been downloaded its value is TRUE, else is FALSE
     * @type {boolean}
     * @memberof DocumentBean
     */
    'downloaded'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentBean
     */
    'externalUrl'?: string;
    /**
     * Visibility groups of the document (PUBLIC, PRIVATE)
     * @type {Array<string>}
     * @memberof DocumentBean
     */
    'visibilityGroups'?: DocumentBeanVisibilityGroupsEnum;
    /**
     * Contacts to send notification email to
     * @type {Array<ContactInfoBean>}
     * @memberof DocumentBean
     */
    'contactInfoList'?: Array<ContactInfoBean>;
    /**
     * Additional metadata infos of the document
     * @type {{ [key: string]: string; }}
     * @memberof DocumentBean
     */
    'metadata'?: { [key: string]: string; };
    /**
     *
     * @type {DocumentBeanComplexMetadataComplexMetadata}
     * @memberof DocumentBean
     */
    'complexMetadata'?: DocumentBeanComplexMetadataComplexMetadata;
}

export const DocumentBeanVisibilityGroupsEnum = {
    Public: 'PUBLIC',
    Private: 'PRIVATE'
} as const;

export type DocumentBeanVisibilityGroupsEnum = typeof DocumentBeanVisibilityGroupsEnum[keyof typeof DocumentBeanVisibilityGroupsEnum];

/**
 * object result
 * @export
 * @interface DocumentBeanComplexMetadata
 */
export interface DocumentBeanComplexMetadata {
    /**
     * The id of the metadata object
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'id'?: string;
    /**
     * The mime type of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'mimeType'?: string;
    /**
     * The hash of the metadata object
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'hash'?: string;
    /**
     * The category of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'category'?: string;
    /**
     * The scope of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'scope'?: string;
    /**
     * The origin of the document, used to define internal flows, grant univocity with bundleId
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'origin'?: string;
    /**
     * The source of the document, used to define external flows
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'source'?: string;
    /**
     * The name of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'documentName'?: string;
    /**
     * The type of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'documentType'?: string;
    /**
     * Size of the document in bytes
     * @type {number}
     * @memberof DocumentBeanComplexMetadata
     */
    'documentSize'?: number;
    /**
     * The foreign key to the document id on the dms
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'dmsId'?: string;
    /**
     * The document URL
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'documentURL'?: string;
    /**
     * The code of the owner of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'ownerCode'?: string;
    /**
     * The id of the bundle, with this info can group a different files
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'bundleId'?: string;
    /**
     * The status of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'status'?: string;
    /**
     * If the document has been read its value is TRUE, else is FALSE
     * @type {boolean}
     * @memberof DocumentBeanComplexMetadata
     */
    'read'?: boolean;
    /**
     * The creation date of the document
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'creationDate'?: string;
    /**
     * The accrual date of the document (competence date)
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'accrualDate'?: string;
    /**
     * Expiration date, documents will not be searchable after this date
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'expirationDate'?: string;
    /**
     * If the document has been downloaded its value is TRUE, else is FALSE
     * @type {boolean}
     * @memberof DocumentBeanComplexMetadata
     */
    'downloaded'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentBeanComplexMetadata
     */
    'externalUrl'?: string;
    /**
     * Visibility groups of the document (PUBLIC, PRIVATE)
     * @type {Array<string>}
     * @memberof DocumentBeanComplexMetadata
     */
    'visibilityGroups'?: DocumentBeanComplexMetadataVisibilityGroupsEnum;
    /**
     * Contacts to send notification email to
     * @type {Array<ContactInfoBean>}
     * @memberof DocumentBeanComplexMetadata
     */
    'contactInfoList'?: Array<ContactInfoBean>;
    /**
     * Additional metadata infos of the document
     * @type {{ [key: string]: string; }}
     * @memberof DocumentBeanComplexMetadata
     */
    'metadata'?: { [key: string]: string; };
    /**
     *
     * @type {DocumentBeanComplexMetadataComplexMetadata}
     * @memberof DocumentBeanComplexMetadata
     */
    'complexMetadata'?: DocumentBeanComplexMetadataComplexMetadata;
}

export const DocumentBeanComplexMetadataVisibilityGroupsEnum = {
    Public: 'PUBLIC',
    Private: 'PRIVATE'
} as const;

export type DocumentBeanComplexMetadataVisibilityGroupsEnum = typeof DocumentBeanComplexMetadataVisibilityGroupsEnum[keyof typeof DocumentBeanComplexMetadataVisibilityGroupsEnum];

/**
 * @type DocumentBeanComplexMetadataComplexMetadata
 * @export
 */
export type DocumentBeanComplexMetadataComplexMetadata = NewsMetadata | SimpleMetadata;

/**
 *
 * @export
 * @interface DocumentDownloadGroupedRequest
 */
export interface DocumentDownloadGroupedRequest {
    /**
     * The id of the documents to search
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'id'?: Array<string>;
    /**
     * The bundle id of the documents to search
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'bundleId'?: string;
    /**
     * The owner of the document
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'ownerCode'?: string;
    /**
     * To include public document in search
     * @type {boolean}
     * @memberof DocumentDownloadGroupedRequest
     */
    'includePublicDocument'?: boolean;
    /**
     * The category of the document
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'categories'?: Array<string>;
    /**
     * The scope of the document
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'scopes'?: Array<string>;
    /**
     * The origin of the document
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'origin'?: string;
    /**
     * The source of the document
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'source'?: string;
    /**
     * The type of the document
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * Document id in the document store
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'dmsId'?: string;
    /**
     * List of document status to filter
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'status'?: Array<string>;
    /**
     * Filter read or unread documents
     * @type {boolean}
     * @memberof DocumentDownloadGroupedRequest
     */
    'read'?: boolean;
    /**
     * Filter expired or not expired documents. Automatic turn off when expirationDate is set. True only expired documents, False only not expired documents, Empty all documents without filter
     * @type {boolean}
     * @memberof DocumentDownloadGroupedRequest
     */
    'expired'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'externalUrl'?: string;
    /**
     *
     * @type {DateSearchParamFilter}
     * @memberof DocumentDownloadGroupedRequest
     */
    'creationDate'?: DateSearchParamFilter;
    /**
     *
     * @type {DateSearchParamFilter}
     * @memberof DocumentDownloadGroupedRequest
     */
    'expirationDate'?: DateSearchParamFilter;
    /**
     * Filter by complexMetadata sub field
     * @type {{ [key: string]: object; }}
     * @memberof DocumentDownloadGroupedRequest
     */
    'complexMetadata'?: { [key: string]: object; };
    /**
     *
     * @type {TextSearchParamFilter}
     * @memberof DocumentDownloadGroupedRequest
     */
    'textSearch'?: TextSearchParamFilter;
    /**
     * The list of fields to filter with null value
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'fieldsWithNullValueFilter'?: Array<string>;
    /**
     * Grouping conditions for documents
     * @type {Array<string>}
     * @memberof DocumentDownloadGroupedRequest
     */
    'groupByFields': Array<string>;
    /**
     * User id who requested documents download.
     * @type {string}
     * @memberof DocumentDownloadGroupedRequest
     */
    'userId': string;
}
/**
 *
 * @export
 * @interface DocumentMetadataGroupedRequest
 */
export interface DocumentMetadataGroupedRequest {
    /**
     * The id of the documents to search
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'id'?: Array<string>;
    /**
     * The bundle id of the documents to search
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'bundleId'?: string;
    /**
     * The owner of the document
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'ownerCode'?: string;
    /**
     * To include public document in search
     * @type {boolean}
     * @memberof DocumentMetadataGroupedRequest
     */
    'includePublicDocument'?: boolean;
    /**
     * The category of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'categories'?: Array<string>;
    /**
     * The scope of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'scopes'?: Array<string>;
    /**
     * The origin of the document
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'origin'?: string;
    /**
     * The source of the document
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'source'?: string;
    /**
     * The type of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * Document id in the document store
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'dmsId'?: string;
    /**
     * List of document status to filter
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'status'?: Array<string>;
    /**
     * Filter read or unread documents
     * @type {boolean}
     * @memberof DocumentMetadataGroupedRequest
     */
    'read'?: boolean;
    /**
     * Filter expired or not expired documents. Automatic turn off when expirationDate is set. True only expired documents, False only not expired documents, Empty all documents without filter
     * @type {boolean}
     * @memberof DocumentMetadataGroupedRequest
     */
    'expired'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentMetadataGroupedRequest
     */
    'externalUrl'?: string;
    /**
     *
     * @type {DateSearchParamFilter}
     * @memberof DocumentMetadataGroupedRequest
     */
    'creationDate'?: DateSearchParamFilter;
    /**
     *
     * @type {DateSearchParamFilter}
     * @memberof DocumentMetadataGroupedRequest
     */
    'expirationDate'?: DateSearchParamFilter;
    /**
     * Filter by complexMetadata sub field
     * @type {{ [key: string]: object; }}
     * @memberof DocumentMetadataGroupedRequest
     */
    'complexMetadata'?: { [key: string]: object; };
    /**
     *
     * @type {TextSearchParamFilter}
     * @memberof DocumentMetadataGroupedRequest
     */
    'textSearch'?: TextSearchParamFilter;
    /**
     * The list of fields to filter with null value
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'fieldsWithNullValueFilter'?: Array<string>;
    /**
     *
     * @type {Paginator}
     * @memberof DocumentMetadataGroupedRequest
     */
    'paginator': Paginator;
    /**
     * Grouping conditions for documents
     * @type {Array<string>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'groupByFields': Array<string>;
    /**
     * Sorting conditions for documents. The document list inside each grouping will be sorted using these fields
     * @type {Set<OrderByStrategy>}
     * @memberof DocumentMetadataGroupedRequest
     */
    'orderByStrategies'?: Set<OrderByStrategy>;
    /**
     * Option to filter null value
     * @type {boolean}
     * @memberof DocumentMetadataGroupedRequest
     */
    'filterNullValue'?: boolean;
}
/**
 *
 * @export
 * @interface DocumentMetadataRequest
 */
export interface DocumentMetadataRequest {
    /**
     * The id of the documents to search
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'id'?: Array<string>;
    /**
     * The bundle id of the documents to search
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'bundleId'?: string;
    /**
     * The owner of the document
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'ownerCode'?: string;
    /**
     * To include public document in search
     * @type {boolean}
     * @memberof DocumentMetadataRequest
     */
    'includePublicDocument'?: boolean;
    /**
     * The category of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'categories'?: Array<string>;
    /**
     * The scope of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'scopes'?: Array<string>;
    /**
     * The origin of the document
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'origin'?: string;
    /**
     * The source of the document
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'source'?: string;
    /**
     * The type of the document
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * Document id in the document store
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'dmsId'?: string;
    /**
     * List of document status to filter
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'status'?: Array<string>;
    /**
     * Filter read or unread documents
     * @type {boolean}
     * @memberof DocumentMetadataRequest
     */
    'read'?: boolean;
    /**
     * Filter expired or not expired documents. Automatic turn off when expirationDate is set. True only expired documents, False only not expired documents, Empty all documents without filter
     * @type {boolean}
     * @memberof DocumentMetadataRequest
     */
    'expired'?: boolean;
    /**
     * External URL of the document if exists
     * @type {string}
     * @memberof DocumentMetadataRequest
     */
    'externalUrl'?: string;
    /**
     *
     * @type {DateSearchParamFilter}
     * @memberof DocumentMetadataRequest
     */
    'creationDate'?: DateSearchParamFilter;
    /**
     *
     * @type {DateSearchParamFilter}
     * @memberof DocumentMetadataRequest
     */
    'expirationDate'?: DateSearchParamFilter;
    /**
     * Filter by complexMetadata sub field
     * @type {{ [key: string]: object; }}
     * @memberof DocumentMetadataRequest
     */
    'complexMetadata'?: { [key: string]: object; };
    /**
     *
     * @type {TextSearchParamFilter}
     * @memberof DocumentMetadataRequest
     */
    'textSearch'?: TextSearchParamFilter;
    /**
     * The list of fields to filter with null value
     * @type {Array<string>}
     * @memberof DocumentMetadataRequest
     */
    'fieldsWithNullValueFilter'?: Array<string>;
    /**
     *
     * @type {Paginator}
     * @memberof DocumentMetadataRequest
     */
    'paginator': Paginator;
}
/**
 * object result
 * @export
 * @interface DocumentNestedGroup
 */
export interface DocumentNestedGroup {
    /**
     *
     * @type {string}
     * @memberof DocumentNestedGroup
     */
    '@class': string;
}
/**
 * document search filter request
 * @export
 * @interface DocumentSearchFilterRequest
 */
export interface DocumentSearchFilterRequest {
    /**
     * activate filter on customer code
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'customerCode'?: string;
    /**
     * activate filter on customer nominative
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'customerNominative'?: string;
    /**
     * activate filter on behalf customer code
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'customerUserBehalfOfCode'?: string;
    /**
     * activate filter on register code
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'customerUserRegisterCode'?: string;
    /**
     * activate filter on agent code
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'agentCode'?: string;
    /**
     * activate filter on document types
     * @type {Array<string>}
     * @memberof DocumentSearchFilterRequest
     */
    'documentTypes'?: Array<string>;
    /**
     * activate filter on document scopes
     * @type {Array<string>}
     * @memberof DocumentSearchFilterRequest
     */
    'scopes'?: Array<string>;
    /**
     * activate filter on bundle id
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'bundleId'?: string;
    /**
     * activate filter if document is read
     * @type {boolean}
     * @memberof DocumentSearchFilterRequest
     */
    'read'?: boolean;
    /**
     * activate filter on publication date lesser limit
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'publicationDateFrom'?: string;
    /**
     * activate filter on publication date upper limit
     * @type {string}
     * @memberof DocumentSearchFilterRequest
     */
    'publicationDateTo'?: string;
    /**
     * activate filter if document is expired
     * @type {boolean}
     * @memberof DocumentSearchFilterRequest
     */
    'expired'?: boolean;
    /**
     * activate filter if document is near expiration date
     * @type {boolean}
     * @memberof DocumentSearchFilterRequest
     */
    'nearExpire'?: boolean;
    /**
     * activate filter on document presents in signroom
     * @type {boolean}
     * @memberof DocumentSearchFilterRequest
     */
    'signroom'?: boolean;
    /**
     * List of fields to filter with null value. Values allowed as filter are field names: customerUserBehalfOfCode, bundleId, for which null value is compatible.
     * @type {Array<string>}
     * @memberof DocumentSearchFilterRequest
     */
    'fieldsWithNullValueFilter'?: Array<DocumentSearchFilterRequestFieldsWithNullValueFilterEnum>;
    /**
     *
     * @type {Paginator}
     * @memberof DocumentSearchFilterRequest
     */
    'paginator'?: Paginator;
    'status'?: Array<string>;
}

export const DocumentSearchFilterRequestFieldsWithNullValueFilterEnum = {
    CustomerUserBehalfOfCode: 'customerUserBehalfOfCode',
    BundleId: 'bundleId'
} as const;

export type DocumentSearchFilterRequestFieldsWithNullValueFilterEnum = typeof DocumentSearchFilterRequestFieldsWithNullValueFilterEnum[keyof typeof DocumentSearchFilterRequestFieldsWithNullValueFilterEnum];

/**
 * Attribute information of the document type
 * @export
 * @interface DocumentTypeAttributeBean
 */
export interface DocumentTypeAttributeBean {
    /**
     * History mode attribute info, true if history mode enabled for document type
     * @type {boolean}
     * @memberof DocumentTypeAttributeBean
     */
    'history'?: boolean;
    /**
     * Notify mode attribute info, true if notifications are enabled for document type
     * @type {boolean}
     * @memberof DocumentTypeAttributeBean
     */
    'notify'?: boolean;
    /**
     * Template used for document type attribute info
     * @type {string}
     * @memberof DocumentTypeAttributeBean
     */
    'template'?: string;
}
/**
 * object result
 * @export
 * @interface DocumentTypeInfoBean
 */
export interface DocumentTypeInfoBean {
    /**
     * Document type
     * @type {string}
     * @memberof DocumentTypeInfoBean
     */
    'documentType'?: string;
    /**
     * Document scope
     * @type {string}
     * @memberof DocumentTypeInfoBean
     */
    'documentScope'?: string;
    /**
     * Document category
     * @type {string}
     * @memberof DocumentTypeInfoBean
     */
    'documentCategory'?: string;
    /**
     *
     * @type {DocumentTypeAttributeBean}
     * @memberof DocumentTypeInfoBean
     */
    'attributes'?: DocumentTypeAttributeBean;
    /**
     * Additional information extension value list of the document type
     * @type {Array<string>}
     * @memberof DocumentTypeInfoBean
     */
    'extensionValues'?: Array<string>;
}
/**
 * Document User List
 * @export
 * @interface DocumentUser
 */
export interface DocumentUser {
    /**
     * User code
     * @type {string}
     * @memberof DocumentUser
     */
    'code': string;
    /**
     * User role, C=Customer  A=Agent)
     * @type {string}
     * @memberof DocumentUser
     */
    'role': DocumentUserRoleEnum;
    /**
     * User full name
     * @type {string}
     * @memberof DocumentUser
     */
    'name': string;
    /**
     * Hide document user
     * @type {boolean}
     * @memberof DocumentUser
     */
    'docHidden': boolean;
    /**
     * True if user must sign
     * @type {boolean}
     * @memberof DocumentUser
     */
    'signer': boolean;
    /**
     * User BehalOf Code
     * @type {string}
     * @memberof DocumentUser
     */
    'userBehalfOfCode'?: string;
    /**
     * User BehalOf Type, C=Customer A=Agent
     * @type {string}
     * @memberof DocumentUser
     */
    'userBehalfOfType'?: DocumentUserUserBehalfOfTypeEnum;
    /**
     * User register code
     * @type {string}
     * @memberof DocumentUser
     */
    'userRegisterCode'?: string;
    /**
     * Related users
     * @type {Set<string>}
     * @memberof DocumentUser
     */
    'relatedUsers'?: Set<string>;
}

export const DocumentUserRoleEnum = {
    C: 'C',
    A: 'A'
} as const;

export type DocumentUserRoleEnum = typeof DocumentUserRoleEnum[keyof typeof DocumentUserRoleEnum];
export const DocumentUserUserBehalfOfTypeEnum = {
    C: 'C',
    A: 'A'
} as const;

export type DocumentUserUserBehalfOfTypeEnum = typeof DocumentUserUserBehalfOfTypeEnum[keyof typeof DocumentUserUserBehalfOfTypeEnum];

/**
 *
 * @export
 * @interface DownloadBundleRequest
 */
export interface DownloadBundleRequest {
    /**
     * The bundle ids of the documents to download
     * @type {Set<string>}
     * @memberof DownloadBundleRequest
     */
    'bundleIds'?: Set<string>;
    /**
     * User id who requested documents download. Optional attribute.
     * @type {string}
     * @memberof DownloadBundleRequest
     */
    'userId'?: string;
}
/**
 * object result
 * @export
 * @interface DownloadHistoryBean
 */
export interface DownloadHistoryBean {
    /**
     * The document id of the download history entry object
     * @type {string}
     * @memberof DownloadHistoryBean
     */
    'documentId'?: string;
    /**
     * The user id of the download history entry object
     * @type {string}
     * @memberof DownloadHistoryBean
     */
    'userId'?: string;
    /**
     * The download date of the download history entry object
     * @type {string}
     * @memberof DownloadHistoryBean
     */
    'downloadDate'?: string;
    /**
     * The document size of the download history entry object
     * @type {number}
     * @memberof DownloadHistoryBean
     */
    'documentSize'?: number;
}
/**
 *
 * @export
 * @interface DownloadHistoryRequest
 */
export interface DownloadHistoryRequest {
    /**
     * Filter by id of the document downloaded
     * @type {Set<string>}
     * @memberof DownloadHistoryRequest
     */
    'documentIds'?: Set<string>;
    /**
     * Filter by user id who downloaded document
     * @type {Set<string>}
     * @memberof DownloadHistoryRequest
     */
    'userIds'?: Set<string>;
    /**
     * Filter by document download date. Start date value filter.
     * @type {string}
     * @memberof DownloadHistoryRequest
     */
    'startDownloadDate'?: string;
    /**
     * Filter by document download date. End date value filter.
     * @type {string}
     * @memberof DownloadHistoryRequest
     */
    'endDownloadDate'?: string;
    /**
     * Filter by size of the document downloaded. Min size value filter.
     * @type {number}
     * @memberof DownloadHistoryRequest
     */
    'minDocumentSize'?: number;
    /**
     * Filter by size of the document downloaded. Max size value filter.
     * @type {number}
     * @memberof DownloadHistoryRequest
     */
    'maxDocumentSize'?: number;
    /**
     * If true items with null or not null userId are added, also if userId is null or not set
     * @type {boolean}
     * @memberof DownloadHistoryRequest
     */
    'nullOrNotNullUserIdEnabled'?: boolean;
}
/**
 * object result
 * @export
 * @interface DownloadHistoryStatisticBean
 */
export interface DownloadHistoryStatisticBean {
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof DownloadHistoryStatisticBean
     */
    'groupedFieldMap'?: { [key: string]: string; };
    /**
     *
     * @type {number}
     * @memberof DownloadHistoryStatisticBean
     */
    'downloadCount'?: number;
    /**
     *
     * @type {number}
     * @memberof DownloadHistoryStatisticBean
     */
    'downloadTotalSize'?: number;
}
/**
 *
 * @export
 * @interface DownloadHistoryStatisticsRequest
 */
export interface DownloadHistoryStatisticsRequest {
    /**
     *
     * @type {Paginator}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'paginator'?: Paginator;
    /**
     *
     * @type {Set<string>}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'groupFieldSet'?: Set<string>;
    /**
     *
     * @type {string}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'groupDateType'?: DownloadHistoryStatisticsRequestGroupDateTypeEnum;
    /**
     *
     * @type {Set<string>}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'documentIds'?: Set<string>;
    /**
     *
     * @type {Set<string>}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'userIds'?: Set<string>;
    /**
     *
     * @type {string}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'startDownloadDate'?: string;
    /**
     *
     * @type {string}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'endDownloadDate'?: string;
    /**
     *
     * @type {number}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'minDocumentSize'?: number;
    /**
     *
     * @type {number}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'maxDocumentSize'?: number;
    /**
     *
     * @type {number}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'minCumulativeDocumentSize'?: number;
    /**
     *
     * @type {number}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'maxCumulativeDocumentSize'?: number;
    /**
     *
     * @type {boolean}
     * @memberof DownloadHistoryStatisticsRequest
     */
    'nullOrNotNullUserIdEnabled'?: boolean;
}

export const DownloadHistoryStatisticsRequestGroupDateTypeEnum = {
    Year: 'YEAR',
    Month: 'MONTH',
    Day: 'DAY',
    Hour: 'HOUR',
    Minute: 'MINUTE'
} as const;

export type DownloadHistoryStatisticsRequestGroupDateTypeEnum = typeof DownloadHistoryStatisticsRequestGroupDateTypeEnum[keyof typeof DownloadHistoryStatisticsRequestGroupDateTypeEnum];

/**
 *
 * @export
 * @interface DownloadMultiRequest
 */
export interface DownloadMultiRequest {
    /**
     * The id of the documents to download
     * @type {Set<string>}
     * @memberof DownloadMultiRequest
     */
    'ids'?: Set<string>;
    /**
     * User id who requested documents download. Optional attribute.
     * @type {string}
     * @memberof DownloadMultiRequest
     */
    'userId'?: string;
}
/**
 *
 * @export
 * @interface FeqMetadata
 */
export interface FeqMetadata extends SimpleMetadata {
    /**
     * Document data from signroom
     * @type {boolean}
     * @memberof FeqMetadata
     */
    'signroom': boolean;
    /**
     * (Internal use) Signature process type code
     * @type {string}
     * @memberof FeqMetadata
     */
    'processTypeCode'?: string;
    /**
     * Signature date
     * @type {string}
     * @memberof FeqMetadata
     */
    'signDate'?: string;
    /**
     * (Internal use) External signature provider system creation date
     * @type {string}
     * @memberof FeqMetadata
     */
    'envelopeCreationDate'?: string;
    /**
     * (Internal use) External signature provider system id
     * @type {string}
     * @memberof FeqMetadata
     */
    'envelopeId'?: string;
    /**
     * (Internal use) True if the document belongs to a signed bundle
     * @type {boolean}
     * @memberof FeqMetadata
     */
    'signed'?: boolean;
    /**
     * Document Type for legally compliant long-term archiving system
     * @type {string}
     * @memberof FeqMetadata
     */
    'documentClass'?: string;
    /**
     * (Internal use) True if the document must be archived into legally compliant long-term archiving system
     * @type {boolean}
     * @memberof FeqMetadata
     */
    'trustArchive'?: boolean;
    /**
     * Contract id for legally compliant long-term archiving system
     * @type {string}
     * @memberof FeqMetadata
     */
    'contractId'?: string;
}
/**
 *
 * @export
 * @interface FeqMetadataAllOf
 */
export interface FeqMetadataAllOf {
    /**
     * Document data from signroom
     * @type {boolean}
     * @memberof FeqMetadataAllOf
     */
    'signroom'?: boolean;
    /**
     * (Internal use) Signature process type code
     * @type {string}
     * @memberof FeqMetadataAllOf
     */
    'processTypeCode'?: string;
    /**
     * Signature date
     * @type {string}
     * @memberof FeqMetadataAllOf
     */
    'signDate'?: string;
    /**
     * (Internal use) External signature provider system creation date
     * @type {string}
     * @memberof FeqMetadataAllOf
     */
    'envelopeCreationDate'?: string;
    /**
     * (Internal use) External signature provider system id
     * @type {string}
     * @memberof FeqMetadataAllOf
     */
    'envelopeId'?: string;
    /**
     * (Internal use) True if the document belongs to a signed bundle
     * @type {boolean}
     * @memberof FeqMetadataAllOf
     */
    'signed'?: boolean;
    /**
     * Document Type for legally compliant long-term archiving system
     * @type {string}
     * @memberof FeqMetadataAllOf
     */
    'documentClass'?: string;
    /**
     * (Internal use) True if the document must be archived into legally compliant long-term archiving system
     * @type {boolean}
     * @memberof FeqMetadataAllOf
     */
    'trustArchive'?: boolean;
    /**
     * Contract id for legally compliant long-term archiving system
     * @type {string}
     * @memberof FeqMetadataAllOf
     */
    'contractId'?: string;
}
/**
 * HandbookBean (ComplexMetadata)
 * @export
 * @interface HandbookMetadataBean
 */
export interface HandbookMetadataBean extends ComplexMetadata {
}
/**
 * object result
 * @export
 * @interface InfoServiceBean
 */
export interface InfoServiceBean {
    /**
     *
     * @type {string}
     * @memberof InfoServiceBean
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof InfoServiceBean
     */
    'version'?: string;
}
/**
 * InformationOfferBean (ComplexMetadata)
 * @export
 * @interface InformationOfferMetadataBean
 */
export interface InformationOfferMetadataBean extends SimpleMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof InformationOfferMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof InformationOfferMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof InformationOfferMetadataBean
     */
    'practiceType'?: string;
    /**
     * the company of the information offer
     * @type {string}
     * @memberof InformationOfferMetadataBean
     */
    'company'?: string;
}
/**
 *
 * @export
 * @interface InformationOfferMetadataBeanAllOf
 */
export interface InformationOfferMetadataBeanAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof InformationOfferMetadataBeanAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof InformationOfferMetadataBeanAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof InformationOfferMetadataBeanAllOf
     */
    'practiceType'?: string;
    /**
     * the company of the information offer
     * @type {string}
     * @memberof InformationOfferMetadataBeanAllOf
     */
    'company'?: string;
}
/**
 *
 * @export
 * @interface MultipartBody
 */
export interface MultipartBody {
    /**
     *
     * @type {AttachmentContentType}
     * @memberof MultipartBody
     */
    'type'?: AttachmentContentType;
    /**
     *
     * @type {Array<Attachment>}
     * @memberof MultipartBody
     */
    'allAttachments'?: Array<Attachment>;
    /**
     *
     * @type {Array<Attachment>}
     * @memberof MultipartBody
     */
    'childAttachments'?: Array<Attachment>;
    /**
     *
     * @type {Attachment}
     * @memberof MultipartBody
     */
    'rootAttachment'?: Attachment;
}
/**
 *
 * @export
 * @interface NewsMetadata
 */
export interface NewsMetadata extends ComplexMetadata {
    /**
     * Title of news
     * @type {string}
     * @memberof NewsMetadata
     */
    'title'?: string;
    /**
     * Description of news
     * @type {string}
     * @memberof NewsMetadata
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof NewsMetadata
     */
    '@class': string;
}
/**
 *
 * @export
 * @interface NewsMetadataAllOf
 */
export interface NewsMetadataAllOf {
    /**
     * Title of news
     * @type {string}
     * @memberof NewsMetadataAllOf
     */
    'title'?: string;
    /**
     * Description of news
     * @type {string}
     * @memberof NewsMetadataAllOf
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof NewsMetadataAllOf
     */
    '@class'?: string;
}
/**
 * Sorting conditions for documents. The document list inside each grouping will be sorted using these fields
 * @export
 * @interface OrderByStrategy
 */
export interface OrderByStrategy {
    /**
     * the name of the field to sort internal group collection
     * @type {string}
     * @memberof OrderByStrategy
     */
    'orderField': string;
    /**
     * order type of the sort. Default is ASC
     * @type {string}
     * @memberof OrderByStrategy
     */
    'orderType'?: OrderByStrategyOrderTypeEnum;
}

export const OrderByStrategyOrderTypeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type OrderByStrategyOrderTypeEnum = typeof OrderByStrategyOrderTypeEnum[keyof typeof OrderByStrategyOrderTypeEnum];

/**
 * Order used for RTO flow
 * @export
 * @interface OrderMetadataBean
 */
export interface OrderMetadataBean {
    /**
     * Order id
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'id': string;
    /**
     * Order amount
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'amount': string;
    /**
     * Order currency
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'currency'?: string;
    /**
     * Order mandate
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'mandate'?: string;
    /**
     * Order operation
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'operation'?: string;
    /**
     * Order operation description
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'operationDesc'?: string;
    /**
     * Payment Type
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'paymentType'?: string;
    /**
     * Macro product code
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'macroProduct'?: string;
    /**
     * Product company code
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productCompany'?: string;
    /**
     * Product name
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productName': string;
    /**
     * Product code
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productCode': string;
    /**
     * Product ISIN
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productIsin'?: string;
    /**
     * Amount ISO
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'amountIso'?: string;
    /**
     * Product company description
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productCompanyDesc'?: string;
    /**
     * Product type
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'productType': string;
    /**
     * Quantity
     * @type {string}
     * @memberof OrderMetadataBean
     */
    'quantity': string;
    /**
     * Order not appropiate
     * @type {boolean}
     * @memberof OrderMetadataBean
     */
    'notAppropriate'?: OrderMetadataBeanNotAppropriateEnum;
    /**
     * kid exists
     * @type {boolean}
     * @memberof OrderMetadataBean
     */
    'existsKidDoc'?: OrderMetadataBeanExistsKidDocEnum;
}

export const OrderMetadataBeanNotAppropriateEnum = {
    False: false
} as const;

export type OrderMetadataBeanNotAppropriateEnum = typeof OrderMetadataBeanNotAppropriateEnum[keyof typeof OrderMetadataBeanNotAppropriateEnum];
export const OrderMetadataBeanExistsKidDocEnum = {
    False: false,
    True: true
} as const;

export type OrderMetadataBeanExistsKidDocEnum = typeof OrderMetadataBeanExistsKidDocEnum[keyof typeof OrderMetadataBeanExistsKidDocEnum];

/**
 * Paginator info
 * @export
 * @interface Paginator
 */
export interface Paginator {
    /**
     *
     * @type {number}
     * @memberof Paginator
     */
    'total'?: number;
    /**
     *
     * @type {number}
     * @memberof Paginator
     */
    'pageSize'?: number;
    /**
     *
     * @type {number}
     * @memberof Paginator
     */
    'totalPageNumber'?: number;
    /**
     *
     * @type {number}
     * @memberof Paginator
     */
    'current'?: number;
    /**
     *
     * @type {string}
     * @memberof Paginator
     */
    'orderType'?: PaginatorOrderTypeEnum;
    /**
     *
     * @type {string}
     * @memberof Paginator
     */
    'orderBy'?: string;
}

export const PaginatorOrderTypeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type PaginatorOrderTypeEnum = typeof PaginatorOrderTypeEnum[keyof typeof PaginatorOrderTypeEnum];

/**
 * object result
 * @export
 * @interface PermissionServiceBean
 */
export interface PermissionServiceBean {
    /**
     *
     * @type {string}
     * @memberof PermissionServiceBean
     */
    'name'?: string;
    /**
     *
     * @type {Set<string>}
     * @memberof PermissionServiceBean
     */
    'permissions'?: Set<string>;
}
/**
 *
 * @export
 * @interface ReadDocumentRequest
 */
export interface ReadDocumentRequest {
    /**
     *
     * @type {Set<string>}
     * @memberof ReadDocumentRequest
     */
    'documentId': Set<string>;
    /**
     *
     * @type {string}
     * @memberof ReadDocumentRequest
     */
    'userId': string;
    /**
     *
     * @type {string}
     * @memberof ReadDocumentRequest
     */
    'readTime'?: string;
}
/**
 * ReportBean (ComplexMetadata)
 * @export
 * @interface ReportMetadataBean
 */
export interface ReportMetadataBean extends SimpleMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ReportMetadataBean
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ReportMetadataBean
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof ReportMetadataBean
     */
    'practiceType'?: string;
    /**
     * the company of the report metadata
     * @type {string}
     * @memberof ReportMetadataBean
     */
    'company'?: string;
}
/**
 *
 * @export
 * @interface ReportMetadataBeanAllOf
 */
export interface ReportMetadataBeanAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ReportMetadataBeanAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof ReportMetadataBeanAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof ReportMetadataBeanAllOf
     */
    'practiceType'?: string;
    /**
     * the company of the report metadata
     * @type {string}
     * @memberof ReportMetadataBeanAllOf
     */
    'company'?: string;
}
/**
 *
 * @export
 * @interface ResponseCommunicationMetadataBean
 */
export interface ResponseCommunicationMetadataBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseCommunicationMetadataBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseCommunicationMetadataBean
     */
    'message'?: string;
    /**
     *
     * @type {CommunicationMetadataBean}
     * @memberof ResponseCommunicationMetadataBean
     */
    'result'?: CommunicationMetadataBean;
}
/**
 *
 * @export
 * @interface ResponseContractMetadataBean
 */
export interface ResponseContractMetadataBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseContractMetadataBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseContractMetadataBean
     */
    'message'?: string;
    /**
     *
     * @type {ContractMetadataBean}
     * @memberof ResponseContractMetadataBean
     */
    'result'?: ContractMetadataBean;
}
/**
 *
 * @export
 * @interface ResponseDispositionMetadataBean
 */
export interface ResponseDispositionMetadataBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseDispositionMetadataBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseDispositionMetadataBean
     */
    'message'?: string;
    /**
     *
     * @type {DispositionMetadataBean}
     * @memberof ResponseDispositionMetadataBean
     */
    'result'?: DispositionMetadataBean;
}
/**
 *
 * @export
 * @interface ResponseDocumentBeanComplexMetadata
 */
export interface ResponseDocumentBeanComplexMetadata {
    /**
     * response code
     * @type {string}
     * @memberof ResponseDocumentBeanComplexMetadata
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseDocumentBeanComplexMetadata
     */
    'message'?: string;
    /**
     *
     * @type {DocumentBeanComplexMetadata}
     * @memberof ResponseDocumentBeanComplexMetadata
     */
    'result'?: DocumentBeanComplexMetadata;
}
/**
 *
 * @export
 * @interface ResponseFeqMetadata
 */
export interface ResponseFeqMetadata {
    /**
     * response code
     * @type {string}
     * @memberof ResponseFeqMetadata
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseFeqMetadata
     */
    'message'?: string;
    /**
     *
     * @type {FeqMetadata}
     * @memberof ResponseFeqMetadata
     */
    'result'?: FeqMetadata;
}
/**
 *
 * @export
 * @interface ResponseHandbookMetadataBean
 */
export interface ResponseHandbookMetadataBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseHandbookMetadataBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseHandbookMetadataBean
     */
    'message'?: string;
    /**
     *
     * @type {HandbookMetadataBean}
     * @memberof ResponseHandbookMetadataBean
     */
    'result'?: HandbookMetadataBean;
}
/**
 *
 * @export
 * @interface ResponseInfoServiceBean
 */
export interface ResponseInfoServiceBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseInfoServiceBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseInfoServiceBean
     */
    'message'?: string;
    /**
     *
     * @type {InfoServiceBean}
     * @memberof ResponseInfoServiceBean
     */
    'result'?: InfoServiceBean;
}
/**
 *
 * @export
 * @interface ResponseInformationOfferMetadataBean
 */
export interface ResponseInformationOfferMetadataBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseInformationOfferMetadataBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseInformationOfferMetadataBean
     */
    'message'?: string;
    /**
     *
     * @type {InformationOfferMetadataBean}
     * @memberof ResponseInformationOfferMetadataBean
     */
    'result'?: InformationOfferMetadataBean;
}
/**
 *
 * @export
 * @interface ResponseListDocumentBeanComplexMetadata
 */
export interface ResponseListDocumentBeanComplexMetadata {
    /**
     * response code
     * @type {string}
     * @memberof ResponseListDocumentBeanComplexMetadata
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseListDocumentBeanComplexMetadata
     */
    'message'?: string;
    /**
     * object result
     * @type {Array<DocumentBeanComplexMetadata>}
     * @memberof ResponseListDocumentBeanComplexMetadata
     */
    'result'?: Array<DocumentBeanComplexMetadata>;
}
/**
 *
 * @export
 * @interface ResponseListDocumentTypeInfoBean
 */
export interface ResponseListDocumentTypeInfoBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseListDocumentTypeInfoBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseListDocumentTypeInfoBean
     */
    'message'?: string;
    /**
     * object result
     * @type {Array<DocumentTypeInfoBean>}
     * @memberof ResponseListDocumentTypeInfoBean
     */
    'result'?: Array<DocumentTypeInfoBean>;
}
/**
 *
 * @export
 * @interface ResponseLong
 */
export interface ResponseLong {
    /**
     * response code
     * @type {string}
     * @memberof ResponseLong
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseLong
     */
    'message'?: string;
    /**
     * object result
     * @type {number}
     * @memberof ResponseLong
     */
    'result'?: number;
}
/**
 *
 * @export
 * @interface ResponseMapStringString
 */
export interface ResponseMapStringString {
    /**
     * response code
     * @type {string}
     * @memberof ResponseMapStringString
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseMapStringString
     */
    'message'?: string;
    /**
     * object result
     * @type {{ [key: string]: string; }}
     * @memberof ResponseMapStringString
     */
    'result'?: { [key: string]: string; };
}
/**
 *
 * @export
 * @interface ResponseNewsMetadata
 */
export interface ResponseNewsMetadata {
    /**
     * response code
     * @type {string}
     * @memberof ResponseNewsMetadata
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseNewsMetadata
     */
    'message'?: string;
    /**
     *
     * @type {NewsMetadata}
     * @memberof ResponseNewsMetadata
     */
    'result'?: NewsMetadata;
}
/**
 *
 * @export
 * @interface ResponsePaginatedCollectionDownloadHistoryBean
 */
export interface ResponsePaginatedCollectionDownloadHistoryBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePaginatedCollectionDownloadHistoryBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePaginatedCollectionDownloadHistoryBean
     */
    'message'?: string;
    /**
     * object result
     * @type {Array<DownloadHistoryBean>}
     * @memberof ResponsePaginatedCollectionDownloadHistoryBean
     */
    'result'?: Array<DownloadHistoryBean>;
    /**
     *
     * @type {Paginator}
     * @memberof ResponsePaginatedCollectionDownloadHistoryBean
     */
    'paginator'?: Paginator;
}
/**
 *
 * @export
 * @interface ResponsePaginatedCollectionDownloadHistoryStatisticBean
 */
export interface ResponsePaginatedCollectionDownloadHistoryStatisticBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePaginatedCollectionDownloadHistoryStatisticBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePaginatedCollectionDownloadHistoryStatisticBean
     */
    'message'?: string;
    /**
     * object result
     * @type {Array<DownloadHistoryStatisticBean>}
     * @memberof ResponsePaginatedCollectionDownloadHistoryStatisticBean
     */
    'result'?: Array<DownloadHistoryStatisticBean>;
    /**
     *
     * @type {Paginator}
     * @memberof ResponsePaginatedCollectionDownloadHistoryStatisticBean
     */
    'paginator'?: Paginator;
}
/**
 *
 * @export
 * @interface ResponsePaginatedListDocumentBeanComplexMetadata
 */
export interface ResponsePaginatedListDocumentBeanComplexMetadata {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePaginatedListDocumentBeanComplexMetadata
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePaginatedListDocumentBeanComplexMetadata
     */
    'message'?: string;
    /**
     * object result
     * @type {Array<DocumentBeanComplexMetadata>}
     * @memberof ResponsePaginatedListDocumentBeanComplexMetadata
     */
    'result'?: Array<DocumentBeanComplexMetadata>;
    /**
     *
     * @type {Paginator}
     * @memberof ResponsePaginatedListDocumentBeanComplexMetadata
     */
    'paginator'?: Paginator;
}
/**
 *
 * @export
 * @interface ResponsePaginatedMapStringDocumentNestedGroup
 */
export interface ResponsePaginatedMapStringDocumentNestedGroup {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePaginatedMapStringDocumentNestedGroup
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePaginatedMapStringDocumentNestedGroup
     */
    'message'?: string;
    /**
     * object result
     * @type {{ [key: string]: DocumentNestedGroup; }}
     * @memberof ResponsePaginatedMapStringDocumentNestedGroup
     */
    'result'?: { [key: string]: DocumentNestedGroup; };
    /**
     *
     * @type {Paginator}
     * @memberof ResponsePaginatedMapStringDocumentNestedGroup
     */
    'paginator'?: Paginator;
}
/**
 *
 * @export
 * @interface ResponsePermissionServiceBean
 */
export interface ResponsePermissionServiceBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponsePermissionServiceBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponsePermissionServiceBean
     */
    'message'?: string;
    /**
     *
     * @type {PermissionServiceBean}
     * @memberof ResponsePermissionServiceBean
     */
    'result'?: PermissionServiceBean;
}
/**
 *
 * @export
 * @interface ResponseReportMetadataBean
 */
export interface ResponseReportMetadataBean {
    /**
     * response code
     * @type {string}
     * @memberof ResponseReportMetadataBean
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseReportMetadataBean
     */
    'message'?: string;
    /**
     *
     * @type {ReportMetadataBean}
     * @memberof ResponseReportMetadataBean
     */
    'result'?: ReportMetadataBean;
}
/**
 *
 * @export
 * @interface ResponseSaveDocumentResponse
 */
export interface ResponseSaveDocumentResponse {
    /**
     * response code
     * @type {string}
     * @memberof ResponseSaveDocumentResponse
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseSaveDocumentResponse
     */
    'message'?: string;
    /**
     *
     * @type {SaveDocumentResponse}
     * @memberof ResponseSaveDocumentResponse
     */
    'result'?: SaveDocumentResponse;
}
/**
 *
 * @export
 * @interface ResponseSetClass
 */
export interface ResponseSetClass {
    /**
     * response code
     * @type {string}
     * @memberof ResponseSetClass
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseSetClass
     */
    'message'?: string;
}
/**
 *
 * @export
 * @interface ResponseString
 */
export interface ResponseString {
    /**
     * response code
     * @type {string}
     * @memberof ResponseString
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseString
     */
    'message'?: string;
    /**
     * object result
     * @type {string}
     * @memberof ResponseString
     */
    'result'?: string;
}
/**
 *
 * @export
 * @interface ResponseVoid
 */
export interface ResponseVoid {
    /**
     * response code
     * @type {string}
     * @memberof ResponseVoid
     */
    'code'?: string;
    /**
     * response message
     * @type {string}
     * @memberof ResponseVoid
     */
    'message'?: string;
    /**
     * object result
     * @type {object}
     * @memberof ResponseVoid
     */
    'result'?: object;
}
/**
 * object result
 * @export
 * @interface SaveDocumentResponse
 */
export interface SaveDocumentResponse {
    /**
     *
     * @type {string}
     * @memberof SaveDocumentResponse
     */
    'id'?: string;
    /**
     *
     * @type {string}
     * @memberof SaveDocumentResponse
     */
    'dmsId'?: string;
    /**
     *
     * @type {string}
     * @memberof SaveDocumentResponse
     */
    'dmsUrl'?: string;
    /**
     *
     * @type {boolean}
     * @memberof SaveDocumentResponse
     */
    'sendNotification'?: boolean;
}
/**
 *
 * @export
 * @interface SaveDownloadHistoryRequest
 */
export interface SaveDownloadHistoryRequest {
    /**
     * The id of the document downloaded
     * @type {string}
     * @memberof SaveDownloadHistoryRequest
     */
    'documentId': string;
    /**
     * User id who downloaded document. Optional attribute.
     * @type {string}
     * @memberof SaveDownloadHistoryRequest
     */
    'userId'?: string;
    /**
     * The date-time of download event. Optional attribute. If omitted is used now date-time as default value
     * @type {string}
     * @memberof SaveDownloadHistoryRequest
     */
    'downloadDate'?: string;
    /**
     * The size of the document downloaded. Optional attribute
     * @type {number}
     * @memberof SaveDownloadHistoryRequest
     */
    'documentSize'?: number;
}
/**
 *
 * @export
 * @interface SearchDownloadHistoryRequest
 */
export interface SearchDownloadHistoryRequest {
    /**
     * Filter by id of the document downloaded
     * @type {Set<string>}
     * @memberof SearchDownloadHistoryRequest
     */
    'documentIds'?: Set<string>;
    /**
     * Filter by user id who downloaded document
     * @type {Set<string>}
     * @memberof SearchDownloadHistoryRequest
     */
    'userIds'?: Set<string>;
    /**
     * Filter by document download date. Start date value filter.
     * @type {string}
     * @memberof SearchDownloadHistoryRequest
     */
    'startDownloadDate'?: string;
    /**
     * Filter by document download date. End date value filter.
     * @type {string}
     * @memberof SearchDownloadHistoryRequest
     */
    'endDownloadDate'?: string;
    /**
     * Filter by size of the document downloaded. Min size value filter.
     * @type {number}
     * @memberof SearchDownloadHistoryRequest
     */
    'minDocumentSize'?: number;
    /**
     * Filter by size of the document downloaded. Max size value filter.
     * @type {number}
     * @memberof SearchDownloadHistoryRequest
     */
    'maxDocumentSize'?: number;
    /**
     * If true items with null or not null userId are added, also if userId is null or not set
     * @type {boolean}
     * @memberof SearchDownloadHistoryRequest
     */
    'nullOrNotNullUserIdEnabled'?: boolean;
    /**
     *
     * @type {Paginator}
     * @memberof SearchDownloadHistoryRequest
     */
    'paginator': Paginator;
}
/**
 *
 * @export
 * @interface SimpleMetadata
 */
export interface SimpleMetadata extends ComplexMetadata {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof SimpleMetadata
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof SimpleMetadata
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof SimpleMetadata
     */
    'practiceType'?: string;
    /**
     *
     * @type {string}
     * @memberof SimpleMetadata
     */
    '@class': string;
}
/**
 *
 * @export
 * @interface SimpleMetadataAllOf
 */
export interface SimpleMetadataAllOf {
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof SimpleMetadataAllOf
     */
    'customers'?: Array<DocumentUser>;
    /**
     * Document User List
     * @type {Array<DocumentUser>}
     * @memberof SimpleMetadataAllOf
     */
    'agents'?: Array<DocumentUser>;
    /**
     * The type of practice
     * @type {string}
     * @memberof SimpleMetadataAllOf
     */
    'practiceType'?: string;
    /**
     *
     * @type {string}
     * @memberof SimpleMetadataAllOf
     */
    '@class'?: string;
}
/**
 * Search by text in document metadata
 * @export
 * @interface TextSearchParamFilter
 */
export interface TextSearchParamFilter {
    /**
     * The operator to be applied on the field
     * @type {string}
     * @memberof TextSearchParamFilter
     */
    'operator': TextSearchParamFilterOperatorEnum;
    /**
     * The value to be parsed by the operator
     * @type {Array<string>}
     * @memberof TextSearchParamFilter
     */
    'value': Array<string>;
    /**
     * To exclude a word in text search
     * @type {boolean}
     * @memberof TextSearchParamFilter
     */
    'exclusion'?: boolean;
    /**
     * To set the language of text
     * @type {string}
     * @memberof TextSearchParamFilter
     */
    'language'?: string;
    /**
     * To set if search is diacriticSensitive
     * @type {boolean}
     * @memberof TextSearchParamFilter
     */
    'diacriticSensitive'?: boolean;
    /**
     * To set if search is caseSensitive
     * @type {boolean}
     * @memberof TextSearchParamFilter
     */
    'caseSensitive'?: boolean;
}

export const TextSearchParamFilterOperatorEnum = {
    Word: 'WORD',
    Any: 'ANY',
    Phrase: 'PHRASE'
} as const;

export type TextSearchParamFilterOperatorEnum = typeof TextSearchParamFilterOperatorEnum[keyof typeof TextSearchParamFilterOperatorEnum];

/**
 *
 * @export
 * @interface UpdateComplexMetadataRequestComplexMetadata
 */
export interface UpdateComplexMetadataRequestComplexMetadata {
    /**
     *
     * @type {DocumentBeanComplexMetadataComplexMetadata}
     * @memberof UpdateComplexMetadataRequestComplexMetadata
     */
    'The new complex metadata to be saved'?: DocumentBeanComplexMetadataComplexMetadata;
}
/**
 *
 * @export
 * @interface UpdateDocumentRequestComplexMetadata
 */
export interface UpdateDocumentRequestComplexMetadata {
    /**
     * The new ownerCode to be saved
     * @type {string}
     * @memberof UpdateDocumentRequestComplexMetadata
     */
    'ownerCode'?: string;
    /**
     * The new status to be saved
     * @type {string}
     * @memberof UpdateDocumentRequestComplexMetadata
     */
    'status'?: string;
    /**
     * The new expirationDate to be saved
     * @type {string}
     * @memberof UpdateDocumentRequestComplexMetadata
     */
    'expirationDate'?: string;
    /**
     * The new metadata to be saved
     * @type {{ [key: string]: string; }}
     * @memberof UpdateDocumentRequestComplexMetadata
     */
    'metadata'?: { [key: string]: string; };
    /**
     *
     * @type {DocumentBeanComplexMetadataComplexMetadata}
     * @memberof UpdateDocumentRequestComplexMetadata
     */
    'The new complex metadata to be saved'?: DocumentBeanComplexMetadataComplexMetadata;
}
/**
 *
 * @export
 * @interface UpdateMetadataRequest
 */
export interface UpdateMetadataRequest {
    /**
     * The new metadata to be saved
     * @type {{ [key: string]: string; }}
     * @memberof UpdateMetadataRequest
     */
    'metadata'?: { [key: string]: string; };
}
/**
 *
 * @export
 * @interface UploadRequestSwaggerDescriptor
 */
export interface UploadRequestSwaggerDescriptor {
    /**
     * file to upload
     * @type {File}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'content': File;
    /**
     * owner of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'ownerCode'?: string;
    /**
     * type of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'document-type': string;
    /**
     * upload origin
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'origin': string;
    /**
     * source system name
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'source'?: string;
    /**
     * name of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'filename': string;
    /**
     * status of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'status'?: string;
    /**
     * mime-type of the document uploaded
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'mime-type'?: UploadRequestSwaggerDescriptorMimeTypeEnum;
    /**
     * content length of the file to upload
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'size'?: UploadRequestSwaggerDescriptorSizeEnum;
    /**
     *
     * @type {SimpleMetadata}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'complexMetadata': SimpleMetadata;
    /**
     * contact data to notify information list<string>
     * @type {Array<string>}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'contactInfoList'?: Array<string>;
    /**
     * metadata info in format map<string,string>, field subtype: \'application/json\'
     * @type {{ [key: string]: string; }}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'metadata'?: { [key: string]: string; };
    /**
     * document expiration date (dd/MM/yyyy)
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'expirationDate'?: string;
    /**
     * the accrual date (competence date) of the document (dd/MM/yyyy)
     * @type {string}
     * @memberof UploadRequestSwaggerDescriptor
     */
    'accrualDate'?: string;
}

export const UploadRequestSwaggerDescriptorMimeTypeEnum = {
    ApplicationPdf: 'application/pdf'
} as const;

export type UploadRequestSwaggerDescriptorMimeTypeEnum = typeof UploadRequestSwaggerDescriptorMimeTypeEnum[keyof typeof UploadRequestSwaggerDescriptorMimeTypeEnum];
export const UploadRequestSwaggerDescriptorSizeEnum = {
    _0: '0'
} as const;

export type UploadRequestSwaggerDescriptorSizeEnum = typeof UploadRequestSwaggerDescriptorSizeEnum[keyof typeof UploadRequestSwaggerDescriptorSizeEnum];

/**
 *
 * @export
 * @interface UploadRequestWithExternalRefSwaggerDescriptor
 */
export interface UploadRequestWithExternalRefSwaggerDescriptor {
    /**
     * file to upload
     * @type {File}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'content': File;
    /**
     * owner of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'ownerCode'?: string;
    /**
     * type of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'document-type': string;
    /**
     * upload origin
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'origin': string;
    /**
     * Upload external system reference origin, that value should concatenate prefix (EXT_ID_) and external id value . Used in subsequent check-retrieve by external reference value if enabled by retrieveIfAlreadyExistingByExtRef attribute
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'source'?: string;
    /**
     * name of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'filename': string;
    /**
     * status of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'status'?: string;
    /**
     * mime-type of the document uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'mime-type'?: UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum;
    /**
     * content length of the file to upload
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'size'?: UploadRequestWithExternalRefSwaggerDescriptorSizeEnum;
    /**
     *
     * @type {SimpleMetadata}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'complexMetadata': SimpleMetadata;
    /**
     * contact data to notify information list<string>
     * @type {Array<string>}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'contactInfoList'?: Array<string>;
    /**
     * metadata info in format map<string,string>, field subtype: \'application/json\'
     * @type {{ [key: string]: string; }}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'metadata'?: { [key: string]: string; };
    /**
     * document expiration date (dd/MM/yyyy)
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'expirationDate'?: string;
    /**
     * the accrual date (competence date) of the document (dd/MM/yyyy)
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'accrualDate'?: string;
    /**
     * True or false value is expected. If it is true enabled check if document already existing and retrieve previous document if it exists. External reference expected in origin attribute value
     * @type {boolean}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'retrieveIfAlreadyExistingByExtRef'?: boolean;
    /**
     * If id is not empty will and if document already existing, then previous document will be deleted and document will be re-uploaded
     * @type {string}
     * @memberof UploadRequestWithExternalRefSwaggerDescriptor
     */
    'documentIdToRecreate'?: string;
}

export const UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum = {
    ApplicationPdf: 'application/pdf'
} as const;

export type UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum = typeof UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum[keyof typeof UploadRequestWithExternalRefSwaggerDescriptorMimeTypeEnum];
export const UploadRequestWithExternalRefSwaggerDescriptorSizeEnum = {
    _0: '0'
} as const;

export type UploadRequestWithExternalRefSwaggerDescriptorSizeEnum = typeof UploadRequestWithExternalRefSwaggerDescriptorSizeEnum[keyof typeof UploadRequestWithExternalRefSwaggerDescriptorSizeEnum];


/**
 * AzDocumentProviderApi - axios parameter creator
 * @export
 */
export const AzDocumentProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Searches documents by metadata and returns document count
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDocumentsByFilter1: async (documentSearchFilterRequest?: DocumentSearchFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/metadata/az-document/countDocumentsByFilter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentSearchFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Searches documents by metadata and returns them in a list
         * @param {boolean} [behalf] Specify if the search is performed on behalf of PG
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsByFilter1: async (behalf?: boolean, documentSearchFilterRequest?: DocumentSearchFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/metadata/az-document/searchDocumentsByFilter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (behalf !== undefined) {
                localVarQueryParameter['behalf'] = behalf;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentSearchFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Searches documents by metadata and returns them grouping by bundleId
         * @param {boolean} [behalf] Specify if the search is performed on behalf of PG
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsGroupedByBundle1: async (behalf?: boolean, documentSearchFilterRequest?: DocumentSearchFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/metadata/az-document/searchDocumentsGroupedByBundle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (behalf !== undefined) {
                localVarQueryParameter['behalf'] = behalf;
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentSearchFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Searches documents by metadata and returns them grouping by customerCode
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsGroupedByCustomer1: async (documentSearchFilterRequest?: DocumentSearchFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/metadata/az-document/searchDocumentsGroupedByCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentSearchFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AzDocumentProviderApi - functional programming interface
 * @export
 */
export const AzDocumentProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AzDocumentProviderApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Searches documents by metadata and returns document count
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countDocumentsByFilter1(documentSearchFilterRequest?: DocumentSearchFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseLong>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countDocumentsByFilter1(documentSearchFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Searches documents by metadata and returns them in a list
         * @param {boolean} [behalf] Specify if the search is performed on behalf of PG
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDocumentsByFilter1(behalf?: boolean, documentSearchFilterRequest?: DocumentSearchFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePaginatedListDocumentBeanComplexMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDocumentsByFilter1(behalf, documentSearchFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Searches documents by metadata and returns them grouping by bundleId
         * @param {boolean} [behalf] Specify if the search is performed on behalf of PG
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDocumentsGroupedByBundle1(behalf?: boolean, documentSearchFilterRequest?: DocumentSearchFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePaginatedMapStringDocumentNestedGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDocumentsGroupedByBundle1(behalf, documentSearchFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Searches documents by metadata and returns them grouping by customerCode
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDocumentsGroupedByCustomer1(documentSearchFilterRequest?: DocumentSearchFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePaginatedMapStringDocumentNestedGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDocumentsGroupedByCustomer1(documentSearchFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AzDocumentProviderApi - factory interface
 * @export
 */
export const AzDocumentProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AzDocumentProviderApiFp(configuration)
    return {
        /**
         *
         * @summary Searches documents by metadata and returns document count
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDocumentsByFilter1(documentSearchFilterRequest?: DocumentSearchFilterRequest, options?: any): AxiosPromise<ResponseLong> {
            return localVarFp.countDocumentsByFilter1(documentSearchFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Searches documents by metadata and returns them in a list
         * @param {boolean} [behalf] Specify if the search is performed on behalf of PG
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsByFilter1(behalf?: boolean, documentSearchFilterRequest?: DocumentSearchFilterRequest, options?: any): AxiosPromise<ResponsePaginatedListDocumentBeanComplexMetadata> {
            return localVarFp.searchDocumentsByFilter1(behalf, documentSearchFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Searches documents by metadata and returns them grouping by bundleId
         * @param {boolean} [behalf] Specify if the search is performed on behalf of PG
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsGroupedByBundle1(behalf?: boolean, documentSearchFilterRequest?: DocumentSearchFilterRequest, options?: any): AxiosPromise<ResponsePaginatedMapStringDocumentNestedGroup> {
            return localVarFp.searchDocumentsGroupedByBundle1(behalf, documentSearchFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Searches documents by metadata and returns them grouping by customerCode
         * @param {DocumentSearchFilterRequest} [documentSearchFilterRequest] request filter, to activate the filter the specific field must be valued
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsGroupedByCustomer1(documentSearchFilterRequest?: DocumentSearchFilterRequest, options?: any): AxiosPromise<ResponsePaginatedMapStringDocumentNestedGroup> {
            return localVarFp.searchDocumentsGroupedByCustomer1(documentSearchFilterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for countDocumentsByFilter1 operation in AzDocumentProviderApi.
 * @export
 * @interface AzDocumentProviderApiCountDocumentsByFilter1Request
 */
export interface AzDocumentProviderApiCountDocumentsByFilter1Request {
    /**
     * request filter, to activate the filter the specific field must be valued
     * @type {DocumentSearchFilterRequest}
     * @memberof AzDocumentProviderApiCountDocumentsByFilter1
     */
    readonly documentSearchFilterRequest?: DocumentSearchFilterRequest
}

/**
 * Request parameters for searchDocumentsByFilter1 operation in AzDocumentProviderApi.
 * @export
 * @interface AzDocumentProviderApiSearchDocumentsByFilter1Request
 */
export interface AzDocumentProviderApiSearchDocumentsByFilter1Request {
    /**
     * Specify if the search is performed on behalf of PG
     * @type {boolean}
     * @memberof AzDocumentProviderApiSearchDocumentsByFilter1
     */
    readonly behalf?: boolean

    /**
     * request filter, to activate the filter the specific field must be valued
     * @type {DocumentSearchFilterRequest}
     * @memberof AzDocumentProviderApiSearchDocumentsByFilter1
     */
    readonly documentSearchFilterRequest?: DocumentSearchFilterRequest
}

/**
 * Request parameters for searchDocumentsGroupedByBundle1 operation in AzDocumentProviderApi.
 * @export
 * @interface AzDocumentProviderApiSearchDocumentsGroupedByBundle1Request
 */
export interface AzDocumentProviderApiSearchDocumentsGroupedByBundle1Request {
    /**
     * Specify if the search is performed on behalf of PG
     * @type {boolean}
     * @memberof AzDocumentProviderApiSearchDocumentsGroupedByBundle1
     */
    readonly behalf?: boolean

    /**
     * request filter, to activate the filter the specific field must be valued
     * @type {DocumentSearchFilterRequest}
     * @memberof AzDocumentProviderApiSearchDocumentsGroupedByBundle1
     */
    readonly documentSearchFilterRequest?: DocumentSearchFilterRequest
}

/**
 * Request parameters for searchDocumentsGroupedByCustomer1 operation in AzDocumentProviderApi.
 * @export
 * @interface AzDocumentProviderApiSearchDocumentsGroupedByCustomer1Request
 */
export interface AzDocumentProviderApiSearchDocumentsGroupedByCustomer1Request {
    /**
     * request filter, to activate the filter the specific field must be valued
     * @type {DocumentSearchFilterRequest}
     * @memberof AzDocumentProviderApiSearchDocumentsGroupedByCustomer1
     */
    readonly documentSearchFilterRequest?: DocumentSearchFilterRequest
}

/**
 * AzDocumentProviderApi - object-oriented interface
 * @export
 * @class AzDocumentProviderApi
 * @extends {BaseAPI}
 */
export class AzDocumentProviderApi extends BaseAPI {
    /**
     *
     * @summary Searches documents by metadata and returns document count
     * @param {AzDocumentProviderApiCountDocumentsByFilter1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AzDocumentProviderApi
     */
    public countDocumentsByFilter1(requestParameters: AzDocumentProviderApiCountDocumentsByFilter1Request = {}, options?: AxiosRequestConfig) {
        return AzDocumentProviderApiFp(this.configuration).countDocumentsByFilter1(requestParameters.documentSearchFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Searches documents by metadata and returns them in a list
     * @param {AzDocumentProviderApiSearchDocumentsByFilter1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AzDocumentProviderApi
     */
    public searchDocumentsByFilter1(requestParameters: AzDocumentProviderApiSearchDocumentsByFilter1Request = {}, options?: AxiosRequestConfig) {
        return AzDocumentProviderApiFp(this.configuration).searchDocumentsByFilter1(requestParameters.behalf, requestParameters.documentSearchFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Searches documents by metadata and returns them grouping by bundleId
     * @param {AzDocumentProviderApiSearchDocumentsGroupedByBundle1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AzDocumentProviderApi
     */
    public searchDocumentsGroupedByBundle1(requestParameters: AzDocumentProviderApiSearchDocumentsGroupedByBundle1Request = {}, options?: AxiosRequestConfig) {
        return AzDocumentProviderApiFp(this.configuration).searchDocumentsGroupedByBundle1(requestParameters.behalf, requestParameters.documentSearchFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Searches documents by metadata and returns them grouping by customerCode
     * @param {AzDocumentProviderApiSearchDocumentsGroupedByCustomer1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AzDocumentProviderApi
     */
    public searchDocumentsGroupedByCustomer1(requestParameters: AzDocumentProviderApiSearchDocumentsGroupedByCustomer1Request = {}, options?: AxiosRequestConfig) {
        return AzDocumentProviderApiFp(this.configuration).searchDocumentsGroupedByCustomer1(requestParameters.documentSearchFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComplexMetadataProviderApi - axios parameter creator
 * @export
 */
export const ComplexMetadataProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary load complex metadata infos of Metadata type, used for digital sign flows
         * @param {string} id load complex metadata Feq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractMetadataBean1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contractMetadataBean1', 'id', id)
            const localVarPath = `/document/metadata/complex-metadata/contractMetadataBean/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary load complex metadata infos of Metadata type, used for digital sign flows
         * @param {string} id load complex metadata Feq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feqMetadata1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('feqMetadata1', 'id', id)
            const localVarPath = `/document/metadata/complex-metadata/feqMetadata/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary load complexMetadata by id
         * @param {string} id load metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadCommunicationMetadataBean1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loadCommunicationMetadataBean1', 'id', id)
            const localVarPath = `/document/metadata/complex-metadata/communicationMetadataBean/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary load complex metadata infos of DispositionData type, used for digital sign flows
         * @param {string} id load complex metadata DispositionData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDispositionMetadataBean1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loadDispositionMetadataBean1', 'id', id)
            const localVarPath = `/document/metadata/complex-metadata/dispositionMetadataBean/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary load complex metadata infos of HandbookBean type
         * @param {string} id load complex metadata HandbookBean
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadHandbookMetadataBean1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loadHandbookMetadataBean1', 'id', id)
            const localVarPath = `/document/metadata/complex-metadata/handbookMetadataBean/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary load complex metadata infos of InformationOfferBean type
         * @param {string} id load complex metadata InformationOfferBean
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadInformationOfferMetadataBean1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loadInformationOfferMetadataBean1', 'id', id)
            const localVarPath = `/document/metadata/complex-metadata/informationOfferMetadataBean/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary load complex metadata infos of ReportBean type
         * @param {string} id load complex metadata ReportBean
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadReportMetadataBean1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loadReportMetadataBean1', 'id', id)
            const localVarPath = `/document/metadata/complex-metadata/reportMetadataBean/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary load complex metadata infos of NewsMetadata type
         * @param {string} id load complex metadata News
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsMetadata1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('newsMetadata1', 'id', id)
            const localVarPath = `/document/metadata/complex-metadata/newsMetadata/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComplexMetadataProviderApi - functional programming interface
 * @export
 */
export const ComplexMetadataProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComplexMetadataProviderApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary load complex metadata infos of Metadata type, used for digital sign flows
         * @param {string} id load complex metadata Feq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contractMetadataBean1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseContractMetadataBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contractMetadataBean1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary load complex metadata infos of Metadata type, used for digital sign flows
         * @param {string} id load complex metadata Feq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feqMetadata1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFeqMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feqMetadata1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary load complexMetadata by id
         * @param {string} id load metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadCommunicationMetadataBean1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCommunicationMetadataBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadCommunicationMetadataBean1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary load complex metadata infos of DispositionData type, used for digital sign flows
         * @param {string} id load complex metadata DispositionData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadDispositionMetadataBean1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseDispositionMetadataBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadDispositionMetadataBean1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary load complex metadata infos of HandbookBean type
         * @param {string} id load complex metadata HandbookBean
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadHandbookMetadataBean1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseHandbookMetadataBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadHandbookMetadataBean1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary load complex metadata infos of InformationOfferBean type
         * @param {string} id load complex metadata InformationOfferBean
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadInformationOfferMetadataBean1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseInformationOfferMetadataBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadInformationOfferMetadataBean1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary load complex metadata infos of ReportBean type
         * @param {string} id load complex metadata ReportBean
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadReportMetadataBean1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseReportMetadataBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadReportMetadataBean1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary load complex metadata infos of NewsMetadata type
         * @param {string} id load complex metadata News
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newsMetadata1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseNewsMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newsMetadata1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComplexMetadataProviderApi - factory interface
 * @export
 */
export const ComplexMetadataProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComplexMetadataProviderApiFp(configuration)
    return {
        /**
         *
         * @summary load complex metadata infos of Metadata type, used for digital sign flows
         * @param {string} id load complex metadata Feq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractMetadataBean1(id: string, options?: any): AxiosPromise<ResponseContractMetadataBean> {
            return localVarFp.contractMetadataBean1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary load complex metadata infos of Metadata type, used for digital sign flows
         * @param {string} id load complex metadata Feq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feqMetadata1(id: string, options?: any): AxiosPromise<ResponseFeqMetadata> {
            return localVarFp.feqMetadata1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary load complexMetadata by id
         * @param {string} id load metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadCommunicationMetadataBean1(id: string, options?: any): AxiosPromise<ResponseCommunicationMetadataBean> {
            return localVarFp.loadCommunicationMetadataBean1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary load complex metadata infos of DispositionData type, used for digital sign flows
         * @param {string} id load complex metadata DispositionData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDispositionMetadataBean1(id: string, options?: any): AxiosPromise<ResponseDispositionMetadataBean> {
            return localVarFp.loadDispositionMetadataBean1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary load complex metadata infos of HandbookBean type
         * @param {string} id load complex metadata HandbookBean
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadHandbookMetadataBean1(id: string, options?: any): AxiosPromise<ResponseHandbookMetadataBean> {
            return localVarFp.loadHandbookMetadataBean1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary load complex metadata infos of InformationOfferBean type
         * @param {string} id load complex metadata InformationOfferBean
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadInformationOfferMetadataBean1(id: string, options?: any): AxiosPromise<ResponseInformationOfferMetadataBean> {
            return localVarFp.loadInformationOfferMetadataBean1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary load complex metadata infos of ReportBean type
         * @param {string} id load complex metadata ReportBean
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadReportMetadataBean1(id: string, options?: any): AxiosPromise<ResponseReportMetadataBean> {
            return localVarFp.loadReportMetadataBean1(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary load complex metadata infos of NewsMetadata type
         * @param {string} id load complex metadata News
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsMetadata1(id: string, options?: any): AxiosPromise<ResponseNewsMetadata> {
            return localVarFp.newsMetadata1(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for contractMetadataBean1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiContractMetadataBean1Request
 */
export interface ComplexMetadataProviderApiContractMetadataBean1Request {
    /**
     * load complex metadata Feq
     * @type {string}
     * @memberof ComplexMetadataProviderApiContractMetadataBean1
     */
    readonly id: string
}

/**
 * Request parameters for feqMetadata1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiFeqMetadata1Request
 */
export interface ComplexMetadataProviderApiFeqMetadata1Request {
    /**
     * load complex metadata Feq
     * @type {string}
     * @memberof ComplexMetadataProviderApiFeqMetadata1
     */
    readonly id: string
}

/**
 * Request parameters for loadCommunicationMetadataBean1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiLoadCommunicationMetadataBean1Request
 */
export interface ComplexMetadataProviderApiLoadCommunicationMetadataBean1Request {
    /**
     * load metadata
     * @type {string}
     * @memberof ComplexMetadataProviderApiLoadCommunicationMetadataBean1
     */
    readonly id: string
}

/**
 * Request parameters for loadDispositionMetadataBean1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiLoadDispositionMetadataBean1Request
 */
export interface ComplexMetadataProviderApiLoadDispositionMetadataBean1Request {
    /**
     * load complex metadata DispositionData
     * @type {string}
     * @memberof ComplexMetadataProviderApiLoadDispositionMetadataBean1
     */
    readonly id: string
}

/**
 * Request parameters for loadHandbookMetadataBean1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiLoadHandbookMetadataBean1Request
 */
export interface ComplexMetadataProviderApiLoadHandbookMetadataBean1Request {
    /**
     * load complex metadata HandbookBean
     * @type {string}
     * @memberof ComplexMetadataProviderApiLoadHandbookMetadataBean1
     */
    readonly id: string
}

/**
 * Request parameters for loadInformationOfferMetadataBean1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiLoadInformationOfferMetadataBean1Request
 */
export interface ComplexMetadataProviderApiLoadInformationOfferMetadataBean1Request {
    /**
     * load complex metadata InformationOfferBean
     * @type {string}
     * @memberof ComplexMetadataProviderApiLoadInformationOfferMetadataBean1
     */
    readonly id: string
}

/**
 * Request parameters for loadReportMetadataBean1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiLoadReportMetadataBean1Request
 */
export interface ComplexMetadataProviderApiLoadReportMetadataBean1Request {
    /**
     * load complex metadata ReportBean
     * @type {string}
     * @memberof ComplexMetadataProviderApiLoadReportMetadataBean1
     */
    readonly id: string
}

/**
 * Request parameters for newsMetadata1 operation in ComplexMetadataProviderApi.
 * @export
 * @interface ComplexMetadataProviderApiNewsMetadata1Request
 */
export interface ComplexMetadataProviderApiNewsMetadata1Request {
    /**
     * load complex metadata News
     * @type {string}
     * @memberof ComplexMetadataProviderApiNewsMetadata1
     */
    readonly id: string
}

/**
 * ComplexMetadataProviderApi - object-oriented interface
 * @export
 * @class ComplexMetadataProviderApi
 * @extends {BaseAPI}
 */
export class ComplexMetadataProviderApi extends BaseAPI {
    /**
     *
     * @summary load complex metadata infos of Metadata type, used for digital sign flows
     * @param {ComplexMetadataProviderApiContractMetadataBean1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public contractMetadataBean1(requestParameters: ComplexMetadataProviderApiContractMetadataBean1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).contractMetadataBean1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary load complex metadata infos of Metadata type, used for digital sign flows
     * @param {ComplexMetadataProviderApiFeqMetadata1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public feqMetadata1(requestParameters: ComplexMetadataProviderApiFeqMetadata1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).feqMetadata1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary load complexMetadata by id
     * @param {ComplexMetadataProviderApiLoadCommunicationMetadataBean1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public loadCommunicationMetadataBean1(requestParameters: ComplexMetadataProviderApiLoadCommunicationMetadataBean1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).loadCommunicationMetadataBean1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary load complex metadata infos of DispositionData type, used for digital sign flows
     * @param {ComplexMetadataProviderApiLoadDispositionMetadataBean1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public loadDispositionMetadataBean1(requestParameters: ComplexMetadataProviderApiLoadDispositionMetadataBean1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).loadDispositionMetadataBean1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary load complex metadata infos of HandbookBean type
     * @param {ComplexMetadataProviderApiLoadHandbookMetadataBean1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public loadHandbookMetadataBean1(requestParameters: ComplexMetadataProviderApiLoadHandbookMetadataBean1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).loadHandbookMetadataBean1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary load complex metadata infos of InformationOfferBean type
     * @param {ComplexMetadataProviderApiLoadInformationOfferMetadataBean1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public loadInformationOfferMetadataBean1(requestParameters: ComplexMetadataProviderApiLoadInformationOfferMetadataBean1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).loadInformationOfferMetadataBean1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary load complex metadata infos of ReportBean type
     * @param {ComplexMetadataProviderApiLoadReportMetadataBean1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public loadReportMetadataBean1(requestParameters: ComplexMetadataProviderApiLoadReportMetadataBean1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).loadReportMetadataBean1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary load complex metadata infos of NewsMetadata type
     * @param {ComplexMetadataProviderApiNewsMetadata1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplexMetadataProviderApi
     */
    public newsMetadata1(requestParameters: ComplexMetadataProviderApiNewsMetadata1Request, options?: AxiosRequestConfig) {
        return ComplexMetadataProviderApiFp(this.configuration).newsMetadata1(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConsoleProviderApi - axios parameter creator
 * @export
 */
export const ConsoleProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary List of available document type and related information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllDocumentType1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/metadata/console/retrieveAllDocumentType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List of fields that can be used for grouping functions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGroupingKeys1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/metadata/console/retrieveGroupingKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsoleProviderApi - functional programming interface
 * @export
 */
export const ConsoleProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConsoleProviderApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary List of available document type and related information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAllDocumentType1(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListDocumentTypeInfoBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAllDocumentType1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List of fields that can be used for grouping functions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveGroupingKeys1(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMapStringString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveGroupingKeys1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConsoleProviderApi - factory interface
 * @export
 */
export const ConsoleProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConsoleProviderApiFp(configuration)
    return {
        /**
         *
         * @summary List of available document type and related information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllDocumentType1(options?: any): AxiosPromise<ResponseListDocumentTypeInfoBean> {
            return localVarFp.retrieveAllDocumentType1(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List of fields that can be used for grouping functions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGroupingKeys1(options?: any): AxiosPromise<ResponseMapStringString> {
            return localVarFp.retrieveGroupingKeys1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConsoleProviderApi - object-oriented interface
 * @export
 * @class ConsoleProviderApi
 * @extends {BaseAPI}
 */
export class ConsoleProviderApi extends BaseAPI {
    /**
     *
     * @summary List of available document type and related information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsoleProviderApi
     */
    public retrieveAllDocumentType1(options?: AxiosRequestConfig) {
        return ConsoleProviderApiFp(this.configuration).retrieveAllDocumentType1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List of fields that can be used for grouping functions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsoleProviderApi
     */
    public retrieveGroupingKeys1(options?: AxiosRequestConfig) {
        return ConsoleProviderApiFp(this.configuration).retrieveGroupingKeys1(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissions1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/metadata/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissions1(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePermissionServiceBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissions1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissions1(options?: any): AxiosPromise<ResponsePermissionServiceBean> {
            return localVarFp.permissions1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public permissions1(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).permissions1(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentProviderApi - axios parameter creator
 * @export
 */
export const DocumentProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Searches documents by metadata and returns them in a list
         * @param {DocumentMetadataRequest} [documentMetadataRequest] Metadata search filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocuments1: async (documentMetadataRequest?: DocumentMetadataRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/metadata/document/searchDocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentMetadataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentProviderApi - functional programming interface
 * @export
 */
export const DocumentProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentProviderApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Searches documents by metadata and returns them in a list
         * @param {DocumentMetadataRequest} [documentMetadataRequest] Metadata search filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDocuments1(documentMetadataRequest?: DocumentMetadataRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePaginatedListDocumentBeanComplexMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDocuments1(documentMetadataRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentProviderApi - factory interface
 * @export
 */
export const DocumentProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentProviderApiFp(configuration)
    return {
        /**
         *
         * @summary Searches documents by metadata and returns them in a list
         * @param {DocumentMetadataRequest} [documentMetadataRequest] Metadata search filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocuments1(documentMetadataRequest?: DocumentMetadataRequest, options?: any): AxiosPromise<ResponsePaginatedListDocumentBeanComplexMetadata> {
            return localVarFp.searchDocuments1(documentMetadataRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for searchDocuments1 operation in DocumentProviderApi.
 * @export
 * @interface DocumentProviderApiSearchDocuments1Request
 */
export interface DocumentProviderApiSearchDocuments1Request {
    /**
     * Metadata search filters
     * @type {DocumentMetadataRequest}
     * @memberof DocumentProviderApiSearchDocuments1
     */
    readonly documentMetadataRequest?: DocumentMetadataRequest
}

/**
 * DocumentProviderApi - object-oriented interface
 * @export
 * @class DocumentProviderApi
 * @extends {BaseAPI}
 */
export class DocumentProviderApi extends BaseAPI {
    /**
     *
     * @summary Searches documents by metadata and returns them in a list
     * @param {DocumentProviderApiSearchDocuments1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentProviderApi
     */
    public searchDocuments1(requestParameters: DocumentProviderApiSearchDocuments1Request = {}, options?: AxiosRequestConfig) {
        return DocumentProviderApiFp(this.configuration).searchDocuments1(requestParameters.documentMetadataRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


